import { makeStylesheetLink } from "../stylesheet";

export class ReadMoreButton extends HTMLElement {
	button: HTMLDivElement;
	expanded: boolean;
	originalText: string;
	truncatedText: string;
	shadow: ShadowRoot;

	constructor() {
		super();
		this.shadow = this.attachShadow({ mode: "open" });

		this.expanded = false;
		this.originalText = "";
		this.truncatedText = "";

		this.button = <div></div> as HTMLDivElement;
		this.button.textContent = "Read More";
		this.button.className = "gct-read-more";

		this.shadow.append(
			this.button,
			makeStylesheetLink(),
		);

		this.toggleText = this.toggleText.bind(this);
	}

	connectedCallback() {
		const article = document.getElementById("short-description");

		if (article) {
			this.originalText = article.innerHTML.trim();
			this.truncatedText = this.truncateText(this.originalText, 160);
			article.innerHTML = this.truncatedText;
			this.button.addEventListener("click", this.toggleText);
		} else {
			console.warn('Element with id="short-description" not found.');
		}
	}

	disconnectedCallback() {
		this.button.removeEventListener("click", this.toggleText);
	}

	truncateText(text: string, maxLength: number): string {
		const stripHtmlTags = (html: string): string => {
			return html.replace(/<[^>]*>/g, "");
		};

		const plainText = stripHtmlTags(text);

		if (plainText.length <= maxLength) {
			return text;
		}

		let truncatedText = plainText.slice(0, maxLength);
		const lastSpaceIndex = truncatedText.lastIndexOf(" ");
		if (lastSpaceIndex > 0) {
			truncatedText = truncatedText.slice(0, lastSpaceIndex);
		}

		const applyTruncationToHtml = (html: string, truncatedPlainText: string): string => {
			let result = "";
			let currentTextLength = 0;
			const tagStack: string[] = [];
			let insideTag = false;

			for (let i = 0; i < html.length; i++) {
				const char = html[i];

				if (char === "<") {
					insideTag = true;
					result += char;
				} else if (char === ">") {
					insideTag = false;
					result += char;
				} else if (!insideTag) {

					if (currentTextLength < truncatedPlainText.length) {
						result += char;
						currentTextLength++;
					} else {
						break;
					}
				} else {

					result += char;
				}
			}

			while (tagStack.length > 0) {
				result += `</${tagStack.pop()}>`;
			}

			return result + "...";
		};

		return applyTruncationToHtml(text, truncatedText);
	}

	toggleText() {
		const article = document.getElementById("short-description");
		if (!article) return;

		this.expanded = !this.expanded;

		if (this.expanded) {
			article.innerHTML = this.originalText;
			this.button.textContent = "Read Less";
		} else {
			article.innerHTML = this.truncatedText;
			this.button.textContent = "Read More";
		}
	}
}

